import React from "react";
import { useLang } from "../context/LanguageContext";
import { ArrowDownRight } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1761155228019-0a29e3f6c8e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBzdGFnZSUyMGxpZ2h0cyUyMGRhcmt8ZW58MHx8fHwxNzc4MjgyNTMwfDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  const { t } = useLang();

  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen w-full overflow-hidden grain" data-testid="hero-section">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt=""
          fetchpriority="high"
          decoding="async"
          className="w-full h-full object-cover scale-110"
          style={{ filter: "grayscale(0.2) contrast(1.05) brightness(0.55)" }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/40" />
      </div>

      {/* Top eyebrow */}
      <div className="relative z-10 pt-44 md:pt-40 px-6 md:px-12">
        <div className="max-w-[1600px] mx-auto">
          <p className="font-mono-tight text-zinc-300" data-testid="hero-eyebrow">
            <span className="inline-block w-8 h-px bg-zinc-500 mr-3 align-middle" />
            {t.hero.eyebrow}
          </p>
        </div>
      </div>

      {/* Content bottom-left */}
      <div className="absolute z-10 bottom-0 left-0 right-0 px-6 md:px-12 pb-16 md:pb-24">
        <div className="max-w-[1600px] mx-auto grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-9">
            <h1
              className="hero-headline text-[14vw] md:text-[10vw] lg:text-[8.5vw] text-white"
              data-testid="hero-headline"
            >
              <span className="block">{t.hero.headline_1}</span>
              <span className="block chrome-text font-editorial italic font-light">
                {t.hero.headline_2}
              </span>
            </h1>
          </div>
          <div className="col-span-12 lg:col-span-3 flex flex-col justify-end gap-6">
            <p className="text-zinc-300 text-sm md:text-base leading-relaxed" data-testid="hero-sub">
              {t.hero.sub}
            </p>
          </div>
        </div>

        <div className="max-w-[1600px] mx-auto mt-10 flex flex-wrap gap-4">
          <button
            onClick={() => goTo("book")}
            className="btn-primary"
            data-testid="hero-cta-book-btn"
          >
            {t.hero.cta_book}
            <ArrowDownRight size={16} />
          </button>
          <button
            onClick={() => goTo("work")}
            className="btn-ghost"
            data-testid="hero-cta-work-btn"
          >
            {t.hero.cta_work}
          </button>
          <button
            onClick={() => goTo("book")}
            className="btn-ghost"
            data-testid="hero-cta-quote-btn"
          >
            {t.hero.cta_quote}
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hidden md:block absolute bottom-8 right-12 z-10">
        <div className="flex items-center gap-3 font-mono-tight text-zinc-400">
          <span>{t.hero.scroll}</span>
          <div className="w-px h-12 bg-gradient-to-b from-zinc-500 to-transparent" />
        </div>
      </div>
    </section>
  );
}
